import { getJson } from '../client'
import type { EventsParams } from '../params'
import { API } from '../paths'
import {
  EVENT_TYPES,
  eventSchema,
  eventsPageSchema,
  type Event,
  type EventsPage,
} from '../schemas/events'

/**
 * Без фильтра по типу запрашиваем только типы журнала (`EVENT_TYPES`), а не «всё, что есть у
 * бэкенда»: в базе бывают события детекций, которых заказчик не показывает (снятый «Опасный
 * предмет» `dangerous_object`, «Падение человека» `falling`). Бэкенд принимает список
 * через запятую. Так чип «Все» равен сумме чипов типов, а KPI и «Последние события» на Главной
 * считают то же самое, что и журнал.
 */
const KNOWN_TYPES = EVENT_TYPES.join(',')

export const eventsApi = {
  getEvents: (params: EventsParams): Promise<EventsPage> =>
    getJson(API.events.list, eventsPageSchema, {
      params: { ...params, type: params.type ?? KNOWN_TYPES },
    }),
  getEvent: (id: string): Promise<Event> => getJson(API.events.byId(id), eventSchema),
}
